import { RSAA } from 'redux-api-middleware'
import queryString from 'query-string'
import * as ApiConstants from '../constants/Api'
import { sessionTokenSelector } from '../reducers/session'
import omit from 'lodash/omit'

const headers = (extraHeaders = {}) => state => {
  const shouldSendSessionHeaders = !extraHeaders.skipSession
  const sessionToken = sessionTokenSelector(state)
  const requestHeaders = {
    'content-type': 'application/vnd.api+json',
    // используется для определения сессии и аккаунта залогинившегося пользователя
    ...(shouldSendSessionHeaders && sessionToken ? { 'Session-Jwt': sessionToken } : {}),
    ...omit(extraHeaders, ['skipSession'])
  }
  // console.log('Headers built: ', requestHeaders)
  return requestHeaders
}

const endpoint = (pathname, query) => {
  const result = `${process.env.REACT_APP_API_URL}${pathname}${
    query ? `${~pathname.indexOf('?') ? '&' : '?'}${queryString.stringify(query)}` : ''
  }`
  // console.log('Endpoint built: ', result)
  return result
}

export const getPromocode = code => ({
  [RSAA]: {
    method: 'GET',
    endpoint: endpoint(`/api/v1/promo_codes/${code}`),
    headers: headers(),
    types: [ApiConstants.GET_PROMOCODE_PENDING, ApiConstants.GET_PROMOCODE_SUCCESS, ApiConstants.GET_PROMOCODE_REJECT]
  }
})

export const postSubscriptionsPromocode = promo_code_code => ({
  [RSAA]: {
    method: 'POST',
    endpoint: endpoint('/api/v1/subscriptions'),
    headers: headers(),
    body: JSON.stringify({
      data: {
        type: 'subscriptions',
        attributes: {
          promo_code_code
        }
      }
    }),
    types: [
      ApiConstants.POST_SUBSCRIPTIONS_PROMOCODE_PENDING,
      ApiConstants.POST_SUBSCRIPTIONS_PROMOCODE_SUCCESS,
      ApiConstants.POST_SUBSCRIPTIONS_PROMOCODE_REJECT
    ]
  }
})

export const patchSubscription = (id, attributes) => async dispatch => {
  await dispatch({
    [RSAA]: {
      method: 'PATCH',
      endpoint: endpoint(`/api/v1/subscriptions/${id}`),
      headers: headers(),
      body: JSON.stringify({
        data: {
          type: 'subscriptions',
          id,
          attributes
        }
      }),
      types: [
        ApiConstants.PATCH_SUBSCRIPTION_PENDING,
        ApiConstants.PATCH_SUBSCRIPTION_SUCCESS,
        ApiConstants.PATCH_SUBSCRIPTION_REJECT
      ]
    }
  })
  await dispatch(getAccount())
}

export const postGoogleAuthorize = attributes => ({
  [RSAA]: {
    method: 'POST',
    endpoint: endpoint('/api/v1/accounts/google_identities/authorize'),
    headers: headers(),
    body: JSON.stringify({
      data: {
        type: 'google_identities',
        attributes
      }
    }),
    types: [
      { type: ApiConstants.POST_SOCIAL_AUTHORIZE_PENDING, meta: { name: 'google' } },
      { type: ApiConstants.POST_SOCIAL_AUTHORIZE_SUCCESS, meta: { name: 'google' } },
      { type: ApiConstants.POST_SOCIAL_AUTHORIZE_REJECT, meta: { name: 'google' } }
    ]
  }
})

export const deleteGoogleUnauthorize = () => ({
  [RSAA]: {
    method: 'DELETE',
    endpoint: endpoint('/api/v1/accounts/google_identities/unauthorize'),
    headers: headers(),
    types: [
      { type: ApiConstants.DELETE_SOCIAL_UNAUTHORIZE_PENDING, meta: { name: 'google' } },
      { type: ApiConstants.DELETE_SOCIAL_UNAUTHORIZE_SUCCESS, meta: { name: 'google' } },
      { type: ApiConstants.DELETE_SOCIAL_UNAUTHORIZE_REJECT, meta: { name: 'google' } }
    ]
  }
})

export const postFacebookAuthorize = attributes => ({
  [RSAA]: {
    method: 'POST',
    endpoint: endpoint('/api/v1/accounts/facebook_identities/authorize'),
    headers: headers(),
    body: JSON.stringify({
      data: {
        type: 'facebook_identities',
        attributes
      }
    }),
    types: [
      { type: ApiConstants.POST_SOCIAL_AUTHORIZE_PENDING, meta: { name: 'facebook' } },
      { type: ApiConstants.POST_SOCIAL_AUTHORIZE_SUCCESS, meta: { name: 'facebook' } },
      { type: ApiConstants.POST_SOCIAL_AUTHORIZE_REJECT, meta: { name: 'facebook' } }
    ]
  }
})

export const deleteFacebookUnauthorize = () => ({
  [RSAA]: {
    method: 'DELETE',
    endpoint: endpoint('/api/v1/accounts/facebook_identities/unauthorize'),
    headers: headers(),
    types: [
      { type: ApiConstants.DELETE_SOCIAL_UNAUTHORIZE_PENDING, meta: { name: 'facebook' } },
      { type: ApiConstants.DELETE_SOCIAL_UNAUTHORIZE_SUCCESS, meta: { name: 'facebook' } },
      { type: ApiConstants.DELETE_SOCIAL_UNAUTHORIZE_REJECT, meta: { name: 'facebook' } }
    ]
  }
})

export const postVkAuthorize = attributes => ({
  [RSAA]: {
    method: 'POST',
    endpoint: endpoint('/api/v1/accounts/vk_identities/authorize'),
    headers: headers(),
    body: JSON.stringify({
      data: {
        type: 'vk_identities',
        attributes
      }
    }),
    types: [
      { type: ApiConstants.POST_SOCIAL_AUTHORIZE_PENDING, meta: { name: 'vk' } },
      { type: ApiConstants.POST_SOCIAL_AUTHORIZE_SUCCESS, meta: { name: 'vk' } },
      { type: ApiConstants.POST_SOCIAL_AUTHORIZE_REJECT, meta: { name: 'vk' } }
    ]
  }
})

export const deleteVkUnauthorize = () => ({
  [RSAA]: {
    method: 'DELETE',
    endpoint: endpoint('/api/v1/accounts/vk_identities/unauthorize'),
    headers: headers(),
    types: [
      { type: ApiConstants.DELETE_SOCIAL_UNAUTHORIZE_PENDING, meta: { name: 'vk' } },
      { type: ApiConstants.DELETE_SOCIAL_UNAUTHORIZE_SUCCESS, meta: { name: 'vk' } },
      { type: ApiConstants.DELETE_SOCIAL_UNAUTHORIZE_REJECT, meta: { name: 'vk' } }
    ]
  }
})

export const postAppleAuthorize = attributes => ({
  [RSAA]: {
    method: 'POST',
    endpoint: endpoint('/api/v1/accounts/apple_identities/authorize'),
    headers: headers(),
    body: JSON.stringify({
      data: {
        type: 'apple_identities',
        attributes
      }
    }),
    types: [
      { type: ApiConstants.POST_SOCIAL_AUTHORIZE_PENDING, meta: { name: 'apple' } },
      { type: ApiConstants.POST_SOCIAL_AUTHORIZE_SUCCESS, meta: { name: 'apple' } },
      { type: ApiConstants.POST_SOCIAL_AUTHORIZE_REJECT, meta: { name: 'apple' } }
    ]
  }
})

export const deleteAppleUnauthorize = () => ({
  [RSAA]: {
    method: 'DELETE',
    endpoint: endpoint('/api/v1/accounts/apple_identities/unauthorize'),
    headers: headers(),
    types: [
      { type: ApiConstants.DELETE_SOCIAL_UNAUTHORIZE_PENDING, meta: { name: 'apple' } },
      { type: ApiConstants.DELETE_SOCIAL_UNAUTHORIZE_SUCCESS, meta: { name: 'apple' } },
      { type: ApiConstants.DELETE_SOCIAL_UNAUTHORIZE_REJECT, meta: { name: 'apple' } }
    ]
  }
})

export const getAccount = () => {
  const query = {
    // при расширении списка нужно не забыть добавить подчистку при DESTROY_SESSION в reducers/data
    include: ['subscriptions', 'phone_identity', 'facebook_identity', 'google_identity', 'vk_identity', 'apple_identity'].join(',')
  }

  return {
    [RSAA]: {
      method: 'GET',
      endpoint: endpoint('/api/v1/account', query),
      headers: headers(),
      types: [ApiConstants.GET_ACCOUNT_PENDING, ApiConstants.GET_ACCOUNT_SUCCESS, ApiConstants.GET_ACCOUNT_REJECT]
    }
  }
}

export const patchAccount = attributes => ({
  [RSAA]: {
    method: 'PATCH',
    endpoint: endpoint('/api/v1/account'),
    headers: headers(),
    body: JSON.stringify({
      data: {
        type: 'accounts',
        attributes
      }
    }),
    types: [ApiConstants.PATCH_ACCOUNT_PENDING, ApiConstants.PATCH_ACCOUNT_SUCCESS, ApiConstants.PATCH_ACCOUNT_REJECT]
  }
})

export const deleteSessionUnauthorize = () => ({
  [RSAA]: {
    method: 'DELETE',
    endpoint: endpoint('/api/v1/accounts/sessions/unauthorize'),
    headers: headers(),
    body: JSON.stringify({
      data: {
        type: 'sessions'
      }
    }),
    types: [
      ApiConstants.DELETE_SESSION_UNAUTHORIZE_PENDING,
      ApiConstants.DELETE_SESSION_UNAUTHORIZE_SUCCESS,
      ApiConstants.DELETE_SESSION_UNAUTHORIZE_REJECT
    ]
  }
})

export const patchEmailIdentities = attributes => ({
  [RSAA]: {
    method: 'PATCH',
    endpoint: endpoint('/api/v1/accounts/email_identities/update'),
    headers: headers(),
    body: JSON.stringify({
      data: {
        type: 'email_identities',
        attributes
      }
    }),
    types: [
      ApiConstants.PATCH_EMAIL_IDENTITIES_PENDING,
      ApiConstants.PATCH_EMAIL_IDENTITIES_SUCCESS,
      ApiConstants.PATCH_EMAIL_IDENTITIES_REJECT
    ]
  }
})

export const patchEmailIdentitiesPassword = attributes => ({
  [RSAA]: {
    method: 'PATCH',
    endpoint: endpoint('/api/v1/accounts/email_identities/update_password'),
    headers: headers(),
    body: JSON.stringify({
      data: {
        type: 'email_identities',
        attributes
      }
    }),
    types: [
      ApiConstants.PATCH_EMAIL_IDENTITIES_PASSWORD_PENDING,
      ApiConstants.PATCH_EMAIL_IDENTITIES_PASSWORD_SUCCESS,
      ApiConstants.PATCH_EMAIL_IDENTITIES_PASSWORD_REJECT
    ]
  }
})

export const postPhoneUpdateRequest = attributes => ({
  [RSAA]: {
    method: 'POST',
    endpoint: endpoint('/api/v1/accounts/phone_identities/update/request_code'),
    headers: headers(),
    body: JSON.stringify({
      data: {
        type: 'phone_identities',
        attributes
      }
    }),
    types: [
      ApiConstants.POST_PHONE_UPDATE_REQUEST_PENDING,
      { type: ApiConstants.POST_PHONE_UPDATE_REQUEST_SUCCESS, meta: attributes },
      ApiConstants.POST_PHONE_UPDATE_REQUEST_REJECT
    ]
  }
})

export const deletePhoneNumber = () => ({
  [RSAA]: {
    method: 'DELETE',
    endpoint: endpoint('/api/v1/accounts/phone_identities/destroy'),
    headers: headers(),
    types: [
      ApiConstants.DELETE_ACCOUNT_PHONE_NUMBER_PENDING,
      ApiConstants.DELETE_ACCOUNT_PHONE_NUMBER_SUCCESS,
      ApiConstants.DELETE_ACCOUNT_PHONE_NUMBER_REJECT
    ]
  }
})

export const postPhoneUpdateVerify = attributes => ({
  [RSAA]: {
    method: 'POST',
    endpoint: endpoint('/api/v1/accounts/phone_identities/update/verify_code'),
    headers: headers(),
    body: JSON.stringify({
      data: {
        type: 'phone_identities',
        attributes
      }
    }),
    types: [
      ApiConstants.POST_PHONE_UPDATE_VERIFY_PENDING,
      { type: ApiConstants.POST_PHONE_UPDATE_VERIFY_SUCCESS, meta: attributes },
      ApiConstants.POST_PHONE_UPDATE_VERIFY_REJECT
    ]
  }
})
